<template>

    <form ref="avaliacaoquestao-form-edit" v-on:submit.prevent="executeEdit(model)" novalidate>

        <div class="row">
            <div class="form-group col-md-12">
                <label for="disciplinaId">Disciplina</label>
                <select v-select="{ dataitem: 'AuxDisciplina', default: 'Selecione' }" v-model="model.disciplinaId" class="form-control" name="disciplinaId" required></select>
            </div>
            <div class="form-group col-md-12">
                <label for="numeroQuestoes">Número de Questões</label>
                <input type="number" class="form-control" name="numeroQuestoes" placeholder="Número de Questões" v-model="model.numeroQuestoes" required />
            </div>
        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeEdit(model)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "avaliacaoquestao-form-edit",
        mixins: [base],
        props: { id: Number },
        data: () => ({

            model: {},

            form: "avaliacaoquestao-form-edit",

            resources: {
                edit: 'avaliacaoquestao',
            },

        }),

        methods: {

            executeEdit: function (model) {

                if (this.formValidate() == false) return;

                new Api(this.resources.edit).put(model).then(data => {
                    this.defaultSuccessResult("Edição realizada com sucesso");
                    this.$emit('on-saved', data)
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                var _valid = $form.checkValidity();
                if (!_valid) this.defaultErrorResult("Preencha todos os campos obrigatórios");
                return _valid;
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },

        mounted() {
            new Api(this.resources.edit).get({ avaliacaoQuestaoId: this.id }).then(data => {
                if (data.data) this.model = data.data;
                else if (!data.dataList) this.model = {};
                else if (data.dataList.length == 1) this.model = data.dataList[0];
                else this.model = {};
            }, err => {
                this.defaultErrorResult(err);
            })
        }
    };
</script>